import React, { useEffect, useState, useRef } from 'react';
import { ControlWrap } from '../wrap';
export function Select({ label, value, onChange, options, disabled, placeholder, valid, searchable }) {
    const valueOption = options === null || options === void 0 ? void 0 : options.find(opt => opt.value === value);
    const valueText = (valueOption === null || valueOption === void 0 ? void 0 : valueOption.label) || '';
    const [open, setOpen] = useState(false);
    return React.createElement(ControlWrap, { label: label, valid: valid },
        React.createElement(Input, { valueText: valueText, disabled: disabled, open: open, placeholder: placeholder, onClick: (ev) => { ev.preventDefault(); setOpen(open => !open); } }),
        open && React.createElement(Menu, { onChange: onChange, options: options, controlValue: value, doClose: () => setOpen(false), searchable: searchable }));
}
const Input = ({ valueText, disabled, onClick, open, placeholder }) => React.createElement("button", { disabled: disabled, className: `ltg-control ltg-select-toggle${open ? ' --open' : ''}`, onClick: onClick },
    valueText || placeholder,
    disabled !== true &&
        React.createElement("div", { className: "ltg-select-chevron-wrap" },
            React.createElement(Chevron, { dir: "down" })));
function normalizeForSearch(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
const Menu = ({ onChange, options, controlValue, doClose, searchable }) => {
    const [query, setQuery] = useState('');
    const inputRef = useRef(null);
    const filteredOptions = searchable && query.trim()
        ? (options || []).filter(opt => normalizeForSearch(opt.label).includes(normalizeForSearch(query)))
        : (options || []);
    useEffect(() => {
        var _a;
        if (searchable) {
            setQuery('');
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [searchable]);
    useEffect(() => {
        const outsideClick = ({ target }) => {
            const menu = target.closest('.ltg-select-menu');
            if (menu)
                return;
            const toggle = target.closest('.ltg-select-toggle');
            if (toggle)
                return;
            doClose();
        };
        document.addEventListener('click', outsideClick);
        return () => {
            document.removeEventListener('click', outsideClick);
        };
    }, []);
    return React.createElement("div", { className: "ltg-select-menu" },
        searchable && (React.createElement("div", { className: "ltg-select-search", onClick: e => e.stopPropagation() },
            React.createElement("input", { ref: inputRef, type: "text", className: "ltg-control ltg-select-search-input", placeholder: "Ie\u0161koti stoties...", value: query, onChange: e => setQuery(e.target.value), onKeyDown: e => e.stopPropagation() }))),
        React.createElement("div", { className: "ltg-select-options-list" }, filteredOptions.length > 0 ? filteredOptions.map(({ label, value }) => {
            return React.createElement("button", { key: 'select-option-' + value, className: `ltg-select-option${value === controlValue ? ' --active' : ''}`, onClick: (ev) => { ev.preventDefault(); onChange && onChange(value); doClose(); } }, label);
        }) : (React.createElement("div", { className: "ltg-select-no-results" }, "Nerasta atitikmen\u0173"))));
};
const Chevron = ({ dir }) => React.createElement("svg", { width: "12", height: "7", style: dir === 'down' ? { transform: "rotate(180deg)" } : undefined, viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 6L6 1L1 6", stroke: "#707070", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }));
